import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const membersSlice = createSlice({
  name: 'members',
  initialState,
  reducers: {},
});

export const {} = membersSlice.actions;
export default membersSlice.reducer;
